import { actions } from "@/store/place/actions";
import { getters } from "@/store/place/getters";
import { mutations } from "@/store/place/mutations";
import { state } from "@/store/place/state";

export default {
    namespaced: true,
    actions,
    getters,
    mutations,
    state,
};
